import script from "./InformationStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./InformationStep.vue?vue&type=script&setup=true&lang=ts"

import "./InformationStep.vue?vue&type=style&index=0&id=e666409e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e666409e"]])

export default __exports__